import { PostGridEvent } from "../events/post_grid_event.js";
import { createFragmentWithData } from "../utilities/elements.js";
import { DickTokComponent } from "./Component.js";
import { defineElement } from "./registry.js";

export class DickTokProfile extends DickTokComponent {
  static services = ["SheetService", "UserApiService"];

  static attributes = [
    { name: "user-id", type: Number },
    { name: "username", type: String },
    { name: "subscribed", type: Boolean },
    { name: "following", type: Boolean },
    { name: "blocked", type: Boolean },
  ];

  connectedCallback() {
    super.connectedCallback();

    // Could possibly do this with data-action but it hasn't been tested with
    // custom events, so just set this up here.
    this.addEventListener(
      PostGridEvent.OPEN_POST,
      (event) => this.#openPosts(event),
      { signal: this.disconnectSignal },
    );
  }

  openOverflowMenu() {
    // Thought: could actually render this as a template element from the
    // server-side component and read it here using data-target. Makes the
    // JavaScript cleaner possibly.
    const manageSubscription = this.subscribed
      ? `<dt-menuitem
            data-action="click:dicktok-profile->openManageSubscription"
            icon-name="rotate-right"
        >
            Manage Subscription
        </dt-menuitem>
        <dt-menudivider></dt-menudivider>`
      : "";
    const data = {
      manageSubscription,
      username: this.username,
      blockLabel: this.blocked ? "Unblock" : "Block",
    };
    const sheet = createFragmentWithData(data)`
      <dt-menu>
          ${"manageSubscription"}
          <dt-menuitem
              data-action="click:dicktok-profile->blockUser"
              icon-name="ban"
          >
              ${"blockLabel"} @${"username"}
          </dt-menuitem>
      </dt-menu>`;
    this.sheetService.open(this, sheet);
  }

  reportUser() {
    this.userApiService.report(this.userId);
    this.sheetService.close();
  }

  async blockUser() {
    if (this.blocked) {
      await this.userApiService.unblock(this.username);
      this.blocked = false;
    } else {
      await this.userApiService.block(this.username);
      this.blocked = true;
    }
    this.sheetService.close();
    // User can't see their posts if blocked, so refresh
    window.location.reload();
  }

  openTipMenu() {
    const data = { username: this.username };
    const sheet = createFragmentWithData(data)`
      Tip ${"username"}`;
    this.sheetService.open(this, sheet);
  }

  openChat() {
    this.log("open chat");
  }

  followUser() {
    this.following
      ? this.userApiService.unfollow(this.username)
      : this.userApiService.follow(this.username);
  }

  openSubscribeMenu() {
    open(`https://justfor.fans/${this.username}?Source=DickTok`, "_blank", {
      noopener: true,
    });
  }

  openManageSubscription() {
    open("https://justfor.fans/subscriptions", "_blank", "noopener");
    this.sheetService.close();
  }

  #openPosts({ target }) {
    open(`/${this.username}/posts?token=${target.dataset.token}`, "_self");
  }
}

defineElement("dicktok-profile", DickTokProfile);
